export default __webpack_public_path__ + "static/media/ObviouslyLight.01d04271.otf";